import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

interface IFsProp {
    isMobile?: boolean;
    fontSize?: string;
    color?: string;
    pt?: string;
    fw?: string;
    lh?: string;
    ls?: string;
    halfBlock?: string;
    isShowcase?: boolean;
  }

export const Text = styled.p<IFsProp>`
    font-size: ${(props) =>
      props.isShowcase ? '15px' : props.fontSize === "" ? "24px" : props.isMobile ? "1rem" : props.fontSize + "px"};
    color: ${(props) =>
      props.color === "" ? + "inherit" : props.color};
    font-weight ${props => props.fw ? `${props.fw}` : "inherit"};
    line-height: ${props => props.lh ? `${props.lh}px` : "inherit"};
    margin: 0;
    padding-top: ${props => props.pt ? `${props.pt}px` : "0"};
    user-select: none;
    cursor: pointer;
    width: ${props => !props.isMobile && props.halfBlock ? `${props.halfBlock}px` : "auto"};
    letter-spacing: ${props => props.ls ? `${props.ls}em` : "normal"};
    font-family: 'Inter';

    // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    //     font-size: 13px;
    //     line-height: 16px;
    // }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 11px;
        line-height: 13px;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const ShowMoreWrapper = styled.div<{ moreOffset?: boolean, open?: boolean }>`


    p, span {
        font-size: 13px;
        line-height: 16px;
    }
    .js-show-more-button {
        display: none;
    }

        ${({ moreOffset }) => moreOffset && css`
            a {
                margin-right: 100%;
            }
        `}
`;

export const SyntheticContainer = styled(FlexBox)`
    span {
        cursor: pointer;
        // color: ${Colors.galBlack27};
        color: #545453;
    }
    :hover {
        span {
            color: rgb(182, 182, 181);
        }        
    }
`;import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

interface IFsProp {
    isMobile?: boolean;
    fontSize?: string;
    color?: string;
    pt?: string;
    fw?: string;
    lh?: string;
    ls?: string;
    halfBlock?: string;
    isShowcase?: boolean;
  }

export const Text = styled.p<IFsProp>`
    font-size: ${(props) =>
      props.isShowcase ? '15px' : props.fontSize === "" ? "24px" : props.isMobile ? "1rem" : props.fontSize + "px"};
    color: ${(props) =>
      props.color === "" ? + "inherit" : props.color};
    font-weight ${props => props.fw ? `${props.fw}` : "inherit"};
    line-height: ${props => props.lh ? `${props.lh}px` : "inherit"};
    margin: 0;
    padding-top: ${props => props.pt ? `${props.pt}px` : "0"};
    user-select: none;
    cursor: pointer;
    width: ${props => !props.isMobile && props.halfBlock ? `${props.halfBlock}px` : "auto"};
    letter-spacing: ${props => props.ls ? `${props.ls}em` : "normal"};
    font-family: 'Inter';

    // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    //     font-size: 13px;
    //     line-height: 16px;
    // }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 11px;
        line-height: 13px;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 11px;
        line-height: 13px;
    }
`;

export const ShowMoreWrapper = styled.div<{ moreOffset?: boolean, open?: boolean }>`


    p, span {
        font-size: 13px;
        line-height: 16px;
    }
    .js-show-more-button {
        display: none;
    }

        ${({ moreOffset }) => moreOffset && css`
            a {
                margin-right: 100%;
            }
        `}
`;

export const SyntheticContainer = styled(FlexBox)`
    span {
        cursor: pointer;
        // color: ${Colors.galBlack27};
        color: #545453;
    }
    :hover {
        span {
            color: rgb(182, 182, 181);
        }        
    }
`;